export default __webpack_public_path__ + "static/media/landing-md.9918709d.webp";